import { PathSegmentResolver } from '../../utils/use-path';

export const resolveBarcodeSearchPath: PathSegmentResolver = ({ defaultLink }) => {
  return {
    title: 'Scanna streckod',
    isPageTitle: true,
    link: defaultLink,
  };
};
